import * as d3 from 'd3'

export default {
  methods: {

    call_Progress(selection, col) {
      
      if (col.status == '') return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(50).style('opacity', .4)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        d3.select(`#STATUS_${this.current.status}_${this.localId}`).attr('font-weight', 400)
        d3.select(`#STATUS_${col.status}_${this.localId}`).attr('font-weight', 450)
        this.current.status = col.status

        this.set_Filtering(col.status) 
      })

    },


    call_Procurement(selection, col, prog) {
      
      if (col.status == '') return
      

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', ()=> {
        d3.select(`#STATUS_${col.status}_${this.localId}`).transition().duration(50).style('opacity', .4)
        d3.select(`#PROG_BAR_${this.localId}`).transition().duration(300).attr('width', prog)
      })
      .on('mouseout', ()=> {
        d3.select(`#STATUS_${col.status}_${this.localId}`).transition().duration(50).style('opacity', 1)
      })
      .on('click', () => {
        d3.select(`#STATUS_${this.current.status}_${this.localId}`).attr('font-weight', 400)
        d3.select(`#STATUS_${col.status}_${this.localId}`).attr('font-weight', 450)
        this.current.status = col.status

        this.set_Filtering(col.status) 
      })

    }, 
    
  }
}